import React from 'react'

/**
 * Component that renders a red asterisk ('*') (usually) used to indicate
 * a required field.
 */
const RequiredAsteriskComponent: React.FC = () => {
  return <span className='text-red-600'> *</span>
}

export default RequiredAsteriskComponent
